import CardioJournal from "./cardioFitnessJournal";
export const fitnessJournalList = [
	{
		id: "cardio",
		icon: "icon icon-cardio",
		color: ["#4DC6C6", "#2393D9"],
		text_color: "#299BD6",
		label: "Cardio",
		shadow: " 0 2px 4px 0 rgba(0,0,0,0.24)",
		unit: "MINUTES"
	},

	{
		id: "resistance",
		icon: "icon icon-resistance",
		color: ["#FF9472", "#E27080"],
		text_color: "#EF807A",
		label: "Resistance",
		shadow: " 0 2px 4px 0 rgba(0,0,0,0.24)",
		unit: "SESSIONS"
	},
	{
		id: "flexibility",
		icon: "icon icon-flexibility",
		color: ["#35CD9B", "#53B85B"],
		text_color: "#4DBC67",
		label: "Flexibility",
		shadow: " 0 2px 4px 0 rgba(0,0,0,0.24)",
		unit: "SESSIONS"
	}
];

export const goalFields = [
	{
		name: "cardio",
		label: "Cardio (total minutes per week)"
	},
	{
		name: "resistance",
		label: "Resistance (Sessions per week)"
	},
	{
		name: "flexibility",
		label: "Flexibility (Sessions per week)"
	},
	{
		name: "calories_burned",
		label: "Calories Burned"
	}
];

export const journalTabs = [
	{
		id: "cardio",
		title: "Cardio",
		component: CardioJournal,
		data: "cardioData"
	},
	{
		id: "resistance",
		title: "Resistance ",
		component: CardioJournal,
		data: "resistanceData",
		type: "resistance"
	},
	{
		id: "flexibility",
		title: "Flexibility",
		component: CardioJournal,
		data: "felxibilityData"
	},
	{
		id: "others",
		title: "Others ",
		component: CardioJournal,
		data: "othersData"
	}
];
